export const actions = {
    axn_loadTwitchInfo({ commit }, auth) {
        commit('set_loadTwitchInfo', auth);
    },

    axn_token({ commit }, token) {
        commit('set_token', token);
    },

    axn_viewerSubscriptionStatus({ commit }, value) {
        commit('set_viewerSubscriptionStatus', value);
    },

    axn_voicemodAccountId( { commit }, value) {
        commit('set_voicemodAccountId', value);
    },

    axn_viewerIsLinked({ commit }, value) {
        commit('set_viewerIsLinked', value);
    },

    axn_isTwitchLinked({ commit }, value) {
        commit('set_isTwitchLinked', value);
    },
};
